import { render, staticRenderFns } from "./CompVamosPaLaCalleModal.vue?vue&type=template&id=75601264&scoped=true"
import script from "./CompVamosPaLaCalleModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CompVamosPaLaCalleModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75601264",
  null
  
)

export default component.exports